import { ApplicationElement, html } from '@effectivastudio/lit-components';
import { ifDefined } from 'lit/directives/if-defined.js';

import '@effectivastudio/lit-components/components/icon_block/element.js';

import style from './style.lit.css';

/**
 * Link element with an icon and slot element for text.
 *
 * @prop href - Link to another page
 * @prop picture - Navigation element's image
 * @prop target - Info where to load the URL
 * @prop name - Internal property => Will be derived from the innerText of the element and will be passed as image description
 *
 * @slot default - For navigation item text
 */

export default class NavigationItemV2 extends ApplicationElement {
  static styles = [ApplicationElement.styles, style];

  static properties = {
    href: { type: String },
    picture: { type: String },
    target: { type: String },
    name: { state: true },
  };

  onSlotChange() {
    this.name = this.innerText;
  }

  render() {
    return html`
      <a href=${this.href} target=${ifDefined(this.target)}>
        <ef-avatar
          .name=${this.name}
          rounded="true"
          picture=${ifDefined(this.picture)}>
        </ef-avatar>
        <slot @slotchange=${this.onSlotChange}></slot>
      </a>
    `;
  }
}

customElements.get('xs-nav-item-v2') ||
  customElements.define('xs-nav-item-v2', NavigationItemV2);
